// extracted by mini-css-extract-plugin
export default {"boundsTable":"styles_boundsTable__nmVD6","title":"styles_title__0rdKC","listHeader":"styles_listHeader__YCI0T","listRow":"styles_listRow__zwEFt","body":"styles_body__S8F68"};